export const getStyled = (theme) => ({
  online: {
    fontSize: 11,
    color: '#25d366',
  },
  offline: {
    fontSize: 11,
    color: '#e1306c',
  },
  cancelButton: {
    color: '#FFF',
    backgroundColor: theme.custom.colors.cancelButton,
  },
  confirmButton: {
    color: '#FFF',
    backgroundColor: theme.custom.colors.confirmButton,
  },
});
